"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const resource_service_1 = require("./../resources/resource.service");
let DateTimeComponent = class DateTimeComponent {
    constructor(_resourceManager, _changeDetectorRef) {
        this._resourceManager = _resourceManager;
        this._changeDetectorRef = _changeDetectorRef;
        this.format = 'EEE MMM/dd <br/> HH:mm:ss';
        this.format2 = '';
        this.TimeChanged = new core_1.EventEmitter();
    }
    get DateTime() {
        return this._date;
    }
    set DateTime(date) {
    }
    ngOnInit() {
        this.updateService();
    }
    ngOnDestroy() {
    }
    updateService() {
        this.updateTime();
        setTimeout(() => this.updateService(), 200);
    }
    updateTime() {
        this._date = new Date();
        this.TimeChanged.emit(this._date);
        this._changeDetectorRef.detectChanges();
    }
    switchFormat() {
        if (this.format === '') {
            return;
        }
        let tempFormat = this.format;
        this.format = this.format2;
        this.format2 = tempFormat;
        this.updateTime();
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateTimeComponent.prototype, "format", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DateTimeComponent.prototype, "format2", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], DateTimeComponent.prototype, "TimeChanged", void 0);
DateTimeComponent = __decorate([
    core_1.Component({
        selector: 'inax-date-time',
        templateUrl: './@inax/commonUi/src/datetime/datetime.component.html',
        styleUrls: ['./@inax/commonUi/src/datetime/datetime.component.css']
    }),
    __metadata("design:paramtypes", [resource_service_1.CommonUiResourceManager,
        core_1.ChangeDetectorRef])
], DateTimeComponent);
exports.DateTimeComponent = DateTimeComponent;
